import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for usersProfiles query
 */
export interface UsersProfilesVariables {
  first?: number;
  last?: number;
  user_Username_Icontains?: string;
}

/**
 * User structure within users profile
 */
export interface UsersProfileUser {
  id: string;
  username: string;
  email: string;
}

/**
 * Users profile node structure (simplified)
 */
export interface UsersProfileNode {
  id: string;
  user: UsersProfileUser;
  role: string | null;
  phoneNumber: string | null;
  firstName: string | null;
  lastName: string | null;
}

/**
 * Users profile edge structure
 */
export interface UsersProfileEdge {
  node: UsersProfileNode;
}

/**
 * All users profiles connection structure
 */
export interface UsersProfilesConnection {
  totalCount: number;
  edges: UsersProfileEdge[];
}

/**
 * Response structure for usersProfiles query
 */
export interface UsersProfilesResponse {
  allProfiles: UsersProfilesConnection;
}

const usersProfiles: DocumentNode = gql`
  query all_profiles($first: Int, $last: Int, $user_Username_Icontains: String) {
    allProfiles(first: $first, last: $last, user_Username_Icontains: $user_Username_Icontains) {
      totalCount
      edges {
        node {
          id
          user {
            id
            username
            email
          }
          role
          phoneNumber
          firstName
          lastName
        }
      }
    }
  }
`;

export default usersProfiles;
